import { useQuery } from 'react-query';
import { menuService } from '../servicesGlobais/menuService';
import { authService } from '../servicesGlobais/authService';

export function useMenu() {
  const hasToken = authService.isAuthenticated();
  
  const {
    data: menuItems = [],
    isLoading,
    error,
    refetch
  } = useQuery(
    ['menu', hasToken],
    () => hasToken 
      ? menuService.obterMenuPorUsuario()
      : menuService.obterMenu(),
    {
      staleTime: 5 * 60 * 1000, // 5 minutos
      cacheTime: 10 * 60 * 1000, // 10 minutos
      enabled: true, // Sempre executa, mas usa endpoint diferente baseado no token
    }
  );

  return {
    menuItems,
    loading: isLoading,
    error: error ? String(error) : null,
    refetch
  };
}

